import React, { useEffect, useState } from 'react'
import { Collapse as AntCollapse, Button } from 'antd'
import { CollapseProps } from 'antd/lib/collapse'

import Panel from './Panel'
import { PanelProps } from './Panel'

type DefaultActiveKeyType = string | string[] | number[]
interface propTypes extends CollapseProps {
  multiCollapseButton?: boolean
  defaultActiveKey: DefaultActiveKeyType
  children: React.ReactNode
}

const Collapse = (props: propTypes) => {
  const {
    multiCollapseButton = false,
    defaultActiveKey,
    children,
    ...rest
  } = props

  const [activatedKey, setActivatedKey] = useState<DefaultActiveKeyType>(
    defaultActiveKey,
  )
  const [allCollapsed, setAllCollapsed] = useState<boolean>(
    !defaultActiveKey.length,
  )

  useEffect(() => {
    setActivatedKey(defaultActiveKey)
    setAllCollapsed(false)
  }, [])

  useEffect(() => {
    setAllCollapsed(!activatedKey.length)
  }, [activatedKey])

  const expandAll = () => setActivatedKey(defaultActiveKey)
  const collapseAll = () => setActivatedKey([])
  const handleOnChange = (key: string | string[]) => setActivatedKey(key)
  const handleOnClick = () => (allCollapsed ? expandAll() : collapseAll())

  const buttonText = allCollapsed ? 'Expand all' : 'Collapse all'
  if (!defaultActiveKey.length) return <div data-testid='empty-collapse' />
  if (!multiCollapseButton)
    return (
      <AntCollapse defaultActiveKey={defaultActiveKey} ghost {...rest}>
        {children}
      </AntCollapse>
    )

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <Button
        type='link'
        onClick={handleOnClick}
        style={{ alignSelf: 'flex-end' }}>
        {buttonText}
      </Button>
      <AntCollapse onChange={handleOnChange} activeKey={activatedKey} ghost {...rest}>
        {children}
      </AntCollapse>
    </div>
  )
}

export default Collapse
export { Panel }
export type { propTypes as CollapseProps, PanelProps }
